import _actions_save from './_actions/save.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    actions:{
        save: _actions_save,
    },
}